import { ServiceId } from "@mirage/discovery/id";
import * as services from "@mirage/discovery/services";

import type { Service } from "@mirage/service-fss-bridge/service";
import type { FSSFile, UnavailableSource } from "./service/bridge_types";

const service = services.getp<Service>(ServiceId.FSS_BRIDGE);
const service$ = services.get<Service>(ServiceId.FSS_BRIDGE);

export function readyPage() {
  return service.readyPage();
}

export function isSupportedEnv() {
  return service.isSupportedEnv();
}

export function openAddSourceModal() {
  return service.openAddSourceModal();
}

export function updateConversation(conversationID: string) {
  return service.updateConversation(conversationID);
}

export function closeSidebar() {
  return service.closeSidebar();
}

export function notifyLogin(uid: number) {
  return service.notifyLogin(uid);
}

export function notifyLogout() {
  return service.notifyLogout();
}

export function openSessionHistory() {
  return service.openSessionHistory();
}

export function openUnavailableSources(
  unavailableSources: UnavailableSource[],
) {
  return service.openUnavailableSources(unavailableSources);
}

export function updateCloseButton(hide: boolean) {
  return service.updateCloseButton(hide);
}

export function transcribeFiles(files: FSSFile[]) {
  return service.transcribeFiles(files);
}

// STACKS FUNCTIONS START
export function notifyInStackDetailPage(
  stackId: string,
  stackName?: string,
  isChatEnabled?: boolean,
  files?: FSSFile[],
) {
  return service.notifyInStackDetailPage(
    stackId,
    stackName,
    isChatEnabled,
    files,
  );
}

export function notifyInStacksPage() {
  return service.notifyInStacksPage();
}

export function notifyInNewStackPage() {
  return service.notifyInNewStackPage();
}

export function startStackChat(files: FSSFile[]) {
  return service.startStackChat(files);
}
// STACKS FUNCTIONS END

export const observeConversationEvents = service$.observeConversationEvents;
export const observeActionEvents = service$.observeActionEvents;
